export default "__VITE_ASSET__5x7pTYZ9__"